import { get, orderBy } from 'lodash';
import { formatDate } from '../../../../utils/dateUtils';

export const getFormattedContactChannelDate = (date) => formatDate(new Date(date), 'M/D/YYYY HH:mm');

export const isChannelContactConfirmed = (channel) => {
    const result = (channel.contactDataItems || []).some((channelContactDataItem) => !!get(channelContactDataItem, 'confirmedDate', null));

    return result;
};

export const checkIsEmptyChannel = (channel) => get(channel, 'contactDataItems.length', 0) === 0;

export const sortChannelContactItemsByDate = (channelContactItems) => orderBy(channelContactItems, ['contactedDate', 'confirmedDate'], 'desc');
